// Per-board accent theming for the verification page (C6 â€” light theming only).
// The rest of Schmidt's branding (app Header/Footer) is untouched; this only
// tints the item card's accent bar/badge based on the board category.

export interface VerifyAccent {
  /** Left accent bar / top rule. */
  bar: string;
  /** Small status pill (e.g. key status). */
  badge: string;
  /** Accent text color for the "In Network" line. */
  text: string;
  /** Soft background for the identity panel. */
  panel: string;
}

const ACCENTS: Record<string, VerifyAccent> = {
  // Hawaii overprint paper money â†’ amber / aged parchment
  'numismatic-paper-money': {
    bar: 'bg-amber-500',
    badge: 'bg-amber-100 text-amber-800 border border-amber-300',
    text: 'text-amber-700',
    panel: 'bg-amber-50',
  },
  // Morgan coins â†’ silver / slate
  'numismatic-coins': {
    bar: 'bg-slate-400',
    badge: 'bg-slate-100 text-slate-700 border border-slate-300',
    text: 'text-slate-700',
    panel: 'bg-slate-50',
  },
  // Topps-era basketball â†’ red / black
  'sports-cards': {
    bar: 'bg-red-600',
    badge: 'bg-red-100 text-red-800 border border-red-300',
    text: 'text-red-700',
    panel: 'bg-gray-50',
  },
};

const DEFAULT_ACCENT: VerifyAccent = {
  bar: 'bg-primary-600',
  badge: 'bg-primary-100 text-primary-800 border border-primary-300',
  text: 'text-primary-700',
  panel: 'bg-gray-50',
};

export function accentFor(boardCategory: string | null | undefined): VerifyAccent {
  if (!boardCategory) return DEFAULT_ACCENT;
  return ACCENTS[boardCategory] || DEFAULT_ACCENT;
}
